import React from "react";
import {withApollo} from "react-apollo";
import SweetAlert from "react-bootstrap-sweetalert";

import withStyles from "material-ui/styles/withStyles";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";


class ExportPinsModal extends React.Component{
    constructor(props){
      super(props)
    }

    render(){
        return(
          <SweetAlert
            onConfirm={(evt) => this.props.exportPins(evt)}
            onCancel={() => this.props.closeExportPinsModal()} 
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
            cancelBtnCssClass={
              this.props.classes.button + " " + this.props.classes.danger
            }
            confirmBtnText="Export"
            cancelBtnText="Cancel"
            showCancel
            title="Export Pins?"
            style={{overflow: "visible !important"}}
          />
        )
    }
}


export default withStyles(sweetAlertStyle)((withApollo(ExportPinsModal)));


// WEBPACK FOOTER //
// ./src/views/projects/components/ExportPinsModal.js